// Side effect imports (CSS/fonts)
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource-variable/lexend";

// Third-party library imports
import * as React from "react";
import { createRoot } from "react-dom/client";
import { Settings as LuxonSettings } from "luxon";
import { RouterProvider } from "react-router-dom";

// Application imports
import { patchDomMethods } from "@/utils/domPatches";
import { router } from "@/routes/router";
import * as logger from "./core/logger";
import * as apm from "./core/apm";

patchDomMethods();
logger.init();
apm.init();

LuxonSettings.defaultZone = "America/Sao_Paulo";
LuxonSettings.defaultLocale = "pt-BR";

const render = () => {
  const containerElement = document.getElementById("container");

  if (!containerElement) {
    throw new Error("Container element not found");
  }

  const rootContainer = createRoot(containerElement);
  rootContainer.render(<RouterProvider router={router} />);
};

render();
